export default __webpack_public_path__ + "static/assisted-stretching-2613b0119381525035529f79a12832ec.jpeg";